import { useQuery } from '@tanstack/react-query';

import {
  AllowedActions,
  IncidentStatus,
  ReportType,
  MetadataClient,
  ProblemDetails,
} from '../../clients';

import queryKeys from '../../queryKeys';

import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);

function useGetAllowedActionsForIncidents(
  formStatus: IncidentStatus | undefined,
  reportType: ReportType | undefined,
) {
  return useQuery<AllowedActions, ProblemDetails>({
    queryKey: [queryKeys.Metadata.GetAllowedFormActionsForIncident, {
      formStatus,
      reportType,
    }],
    queryFn: () => metadataClient.getAllowedFormActionsForIncident(
      reportType,
      formStatus,
    ),
  });
}

export default useGetAllowedActionsForIncidents;
